/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const WorkflowType = {
  NEW: 'NEW',
  CHANGE: 'CHANGE',
  OBSOLETE: 'OBSOLETE',
  OBSOLETE_REFERENCE: 'OBSOLETE_REFERENCE',
  OBSOLETE_PLACEHOLDER: 'OBSOLETE_PLACEHOLDER',
  TRAINING: 'TRAINING',
  IMPORT: 'IMPORT',
  CREATE_REFERENCE: 'CREATE_REFERENCE',
  CREATE_PLACEHOLDER: 'CREATE_PLACEHOLDER',
  FILL_PLACEHOLDER: 'FILL_PLACEHOLDER',
  FILE_ARTIFACT: 'FILE_ARTIFACT',
  RECLASSIFY_DOCUMENT: 'RECLASSIFY_DOCUMENT',
  EOS: 'EOS',
  EOS_DOWNLOAD_AND_ACKNOWLEDGE: 'EOS_DOWNLOAD_AND_ACKNOWLEDGE',
  QC_REVIEW: 'QC_REVIEW'
} as const

export const WorkflowStepType = {
  // Step 1 - Authorization/Approval
  AUTHORIZE_PLACEHOLDER_CREATION: 'AUTHORIZE_PLACEHOLDER_CREATION',
  AUTHORIZE_REFERENCE_CREATION: 'AUTHORIZE_REFERENCE_CREATION',
  AUTHORIZE_MIGRATION: 'AUTHORIZE_MIGRATION',
  AUTHORIZE_FILL_PLACEHOLDER: 'AUTHORIZE_FILL_PLACEHOLDER',
  AUTHORIZE_RECLASSIFICATION: 'AUTHORIZE_RECLASSIFICATION',
  AUTHORIZE_CHANGE_REQUEST: 'AUTHORIZE_CHANGE_REQUEST',
  APPROVE_OBSOLETE: 'APPROVE_OBSOLETE',
  DOWNLOAD_EOS: 'DOWNLOAD_EOS',
  // Step 2 - Revision/Edit
  REVISE_EDIT: 'REVISE_EDIT',
  REVISE_EDIT_MULTIFILE: 'REVISE_EDIT_MULTIFILE',
  REVISE_EDIT_EOS: 'REVISE_EDIT_EOS',
  REVISE_EDIT_MIGRATION: 'REVISE_EDIT_MIGRATION',
  APPROVE_REFERENCE_CREATION: 'APPROVE_REFERENCE_CREATION',
  APPROVE_PLACEHOLDER_CREATION: 'APPROVE_PLACEHOLDER_CREATION',
  APPROVE_OBSOLETING_REFERENCE: 'APPROVE_OBSOLETING_REFERENCE',
  REVISE_EDIT_RECLASSIFICATION: 'REVISE_EDIT_RECLASSIFICATION',
  REVISE_EDIT_FILE_ARTIFACT: 'REVISE_EDIT_FILE_ARTIFACT',
  ACKNOWLEDGE_EOS: 'ACKNOWLEDGE_EOS',
  REVIEW_QC: 'REVIEW_QC',
  APPROVE_QC: 'APPROVE_QC',
  // Step 3 - Review
  REVIEW: 'REVIEW',
  REVIEW_MULTIFILE: 'REVIEW_MULTIFILE',
  REVIEW_EOS: 'REVIEW_EOS',
  REVIEW_RECLASSIFICATION: 'REVIEW_RECLASSIFICATION',
  REVIEW_FILE_ARTIFACT: 'REVIEW_FILE_ARTIFACT',
  // Step 4 - Approval
  APPROVE: 'APPROVE',
  APPROVE_MULTIFILE: 'APPROVE_MULTIFILE',
  APPROVE_MIGRATION: 'APPROVE_MIGRATION',
  APPROVE_EOS: 'APPROVE_EOS',
  APPROVE_RECLASSIFICATION: 'APPROVE_RECLASSIFICATION',
  APPROVE_FILE_ARTIFACT: 'APPROVE_FILE_ARTIFACT',
  // Step 5 - Training
  TRAINING: 'TRAINING'
} as const

export const WorkflowStatus = {
  ACTIVE: 'ACTIVE' as const,
  INACTIVE: 'INACTIVE' as const,
  COMPLETED: 'COMPLETED' as const,
  FINISHED: 'FINISHED' as const,
  SUSPENDED: 'SUSPENDED' as const,
  CANCELLED: 'CANCELLED' as const
} as const

export const TASK_ACTIONS = {
  taskComplete: 'taskComplete',
  taskReassign: 'taskReassign',
  taskReject: 'taskReject'
} as const

export const WorkflowProcessingType = {
  SERIAL: 'SERIAL',
  PARALLEL: 'PARALLEL',
  N_OF_ALL: 'N_OF_ALL'
} as const

export const DocumentTypesAllowedLEVEL = {
  ALL: 'ALL',
  DEFINED_IN_CREATION: 'DEFINED_IN_CREATION',
  DEFINED_ON_FOLDER: 'DEFINED_ON_FOLDER'
}

export type WorkflowTypeType = (typeof WorkflowType)[keyof typeof WorkflowType]
export type WorkflowStepTypeType = (typeof WorkflowStepType)[keyof typeof WorkflowStepType]
export type WorkflowStatusType = (typeof WorkflowStatus)[keyof typeof WorkflowStatus]
export type TaskActionType = (typeof TASK_ACTIONS)[keyof typeof TASK_ACTIONS]
export type WorkflowProcessingTypeType = (typeof WorkflowProcessingType)[keyof typeof WorkflowProcessingType]
